'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentContainer = exports.i = exports.p = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.color = color;
exports.button = button;

var _glamorReact = require('glamor-react');

var _flex = require('../styles/flex');

var _flex2 = _interopRequireDefault(_flex);

var _colors = require('../styles/colors');

var _media = require('../styles/media');

var _helpers = require('../styles/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var p = exports.p = (0, _glamorReact.css)((0, _media.phone)(_extends({}, (0, _helpers.font)('1rem'), { margin: 'auto' })), {
  margin: '0%'
});

var i = exports.i = (0, _glamorReact.css)({
  marginLeft: '0.6rem',
  marginTop: '0.3rem'
});

var contentContainer = exports.contentContainer = (0, _glamorReact.css)((0, _flex2.default)({ direction: 'row' }), {
  width: '100%',
  justifyContent: 'center'
});

function color(buttonColor) {
  if (buttonColor !== _colors.COLORS.WHITE) {
    return (0, _glamorReact.merge)((0, _glamorReact.hover)((0, _colors.background)((0, _colors.hoverColor)(buttonColor))), _extends({}, (0, _colors.background)(buttonColor), (0, _colors.border)(buttonColor)));
  }
  return (0, _glamorReact.merge)((0, _glamorReact.hover)((0, _colors.background)(_colors.COLORS.OFF_WHITE)), _extends({}, (0, _colors.background)(_colors.COLORS.WHITE), (0, _colors.text)(_colors.COLORS.BLUE), {
    borderColor: (0, _colors.dropshadowColor)(_colors.COLORS.BLUE),
    borderBottomColor: (0, _colors.dropshadowColor)(_colors.COLORS.BLUE)
  }));
}

function button(buttonColor) {
  return (0, _glamorReact.merge)((0, _glamorReact.focus)({ outline: 'none' }), (0, _glamorReact.active)({
    boxShadow: 'inset 0 3px 5px rgba(0,0,0,0.15),0 2px 3px rgba(0,0,0,0.05)',
    borderBottom: 'solid 3px ' + (0, _colors.dropshadowColor)(buttonColor),
    borderTop: 'solid 1px',
    outline: 'none'
  }), (0, _colors.text)(_colors.COLORS.WHITE), color(buttonColor), (0, _helpers.padding)('.5rem', '1rem'), (0, _helpers.margin)(10), (0, _helpers.font)('1.2rem'), {
    border: 'none',
    borderRadius: '5px',
    borderBottom: ' 4px solid ' + (0, _colors.dropshadowColor)(buttonColor),
    outline: 'none',
    cursor: 'pointer'
  });
}

exports.default = {
  contentContainer: contentContainer,
  button: button,
  p: p,
  i: i
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Button/styles.js
// module id = 1575
// module chunks = 0